export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/step-start.98aa18ef-539a1f.png";